<template>

  <div class="offline">
    <div class="offline-title">
      <label>选择场</label>
      <el-select filterable
                 v-model="place"
                 placeholder="请选择"
                 @change="changePlace">
        <el-option
          v-for="item in placeList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-button type="primary" class="newAddBtn" @click="toAddNew">新建离线包</el-button>
    </div>
    <div class="offline-body">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="测试环境" name="0">
          <el-table
            class="dataTable"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              label="名称"
              min-width="180">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="包类型"
              width="180">
              <template slot-scope="scope">
                <span>{{ +scope.row.pkg_type?"全量包":"增量包" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="状态"
              width="180">
              <template slot-scope="scope">
                <el-button size="mini" round :type="filterA(scope.row.status).type">{{ filterA(scope.row.status).text }}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="版本"
              width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.version }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.created_at }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">

                <!-- <el-button
                  size="mini"
                  type="primary"
                  @click="handleCopyDownload(scope.$index, scope.row)">
                  copy

                </el-button> -->
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleDownload(scope.$index, scope.row)">
                  下载

                </el-button>
                <el-button
                  v-show="[0,3,4].includes(+scope.row.status)"
                  size="mini"
                  type="warning"
                  @click="handlePublish(scope.$index, scope.row)">发布</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagebar"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="预发布环境" name="1">
          <el-table
            class="dataTable"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              label="名称"
              min-width="180">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="包类型"
              width="180">
              <template slot-scope="scope">
                <span>{{ +scope.row.pkg_type?"全量包":"增量包" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="状态"
              width="180">
              <template slot-scope="scope">
                <el-button size="mini" round :type="filterA(scope.row.status).type">{{ filterA(scope.row.status).text }}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="版本"
              width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.version }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.created_at }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <!-- <el-button
                  size="mini"
                  type="primary"
                  @click="handleCopyDownload(scope.$index, scope.row)">
                  copy

                </el-button> -->
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleDownload(scope.$index, scope.row)">下载</el-button>
                <el-button
                  v-show="[1].includes(+scope.row.status)"
                  size="mini"
                  type="danger"
                  @click="handlePublish(scope.$index, scope.row)">上线</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagebar"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="线上环境" name="2">
          <el-table
            class="dataTable"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              label="名称"
              min-width="180">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="包类型"
              width="180">
              <template slot-scope="scope">
                <span>{{ +scope.row.pkg_type?"全量包":"增量包" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="状态"
              width="180">
              <template slot-scope="scope">
                <el-button size="mini" round :type="filterA(scope.row.status).type">{{ filterA(scope.row.status).text }}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="版本"
              width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.version }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.created_at }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <!-- <el-button
                  size="mini"
                  type="primary"
                  @click="handleCopyDownload(scope.$index, scope.row)">
                  copy

                </el-button> -->
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleDownload(scope.$index, scope.row)">
                  下载
                </el-button>

              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagebar"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </el-tab-pane>

      </el-tabs>
    </div>
    <el-dialog title="新建离线包" :visible.sync="dialogFormVisible" width="200px">
      <el-form :model="form">
        <el-form-item label="包名称" label-width="60px">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <el-checkbox v-model="form.vr_data">VR数据</el-checkbox>
      <el-checkbox v-model="form.map">地图</el-checkbox>
      <el-checkbox v-model="form.align_param">对齐数据</el-checkbox>


      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddPkg">确 定</el-button>
      </div>
    </el-dialog>
    <a
      style="display:none"
      href=""
      id="download">点击下载</a>
  </div>
</template>

<script>
import { fetchplaceList, packageList, createData, updateData, downloadUrl } from '@/api/place';

export default {
  name: 'index',
  data() {
    return {
      placeList: [],
      place: '',
      tableData: [],
      activeName: '0',
      currentPage: 1,
      page_size: 20,
      total: 0,
      dialogFormVisible: false,
      form: {
        name: '',
        vr_data: true,
        map: true,
        align_param: true,
      },

    };
  },
  filters: {

  },
  components: {},
  watch: {},
  computed: {},
  created() {
    this.fetchplaceList();
  },
  mounted() {},
  methods: {

    toAddNew() {
      this.dialogFormVisible = true;
      this.form = {
        name: '',
        vr_data: true,
        map: true,
        align_param: true,
      };
    },
    filterA(v) {
      const map = [{ text: '未发布', type: 'success' }, { text: '未上线', type: 'success' }, { text: '已上线', type: 'success' }, { text: '打包中', type: 'warning' }, { text: '打包失败', type: 'danger' }, { text: '发布', type: 'success' }];
      return map[+v];
    },
    changePlace(e) {
      console.log(e, 'eeeee');
      this.packageList(e, this.activeName);
    },
    async packageList(place_id, status) {
      try {
        const res = await packageList({ place_id, status, page_size: this.page_size, page_num: this.currentPage });// environment: status,
        console.log(res, 'ress');
        this.tableData = res.data.list;
        this.total = res.data.total;
      } catch (e) {
        console.log(e);
      }
    },
    async handleAddPkg() {
      console.log(this.form.vr_data && this.form.map && this.form.align_param, this.form);
      if (!this.form.vr_data && !this.form.map && !this.form.align_param) {
        this.$message.error('请至少勾选一项');
      } else if (!this.form.name) {
        this.$message.error('请填写名称');
      } else {
        this.dialogFormVisible = false;
        console.log(this.form, 'formmmm');
        try {
          const res = await createData({ place_id: this.place, ...this.form, status: this.activeName });
          console.log(res, 'add');
          this.packageList(this.place, this.activeName);
        } catch (e) {
          console.log(e);
        }
      }
    },
    fetchplaceList() {
      fetchplaceList({
        page: 1,
        size: 1000,
      })
        .then((res) => {
          if (res.data.list && res.data.list.length >= 0) {
            this.placeList = res.data.list;
            this.place = this.placeList[0].id;
            this.packageList(this.place, this.activeName);// this.place, this.activeName
          } else {
            this.$message.error(res.error_msg || '服务异常，请稍后重试～');
          }
        });
    },

    handleClick(e) {
      console.log(e, 'tabclick');
      this.packageList(this.place, this.activeName);
    },
    async handleCopyDownload(i, item) {
      try {
        const res = await downloadUrl({ place_id: this.place, version: item.version, status: item.status });
        console.log(res, 'resss');

        if (!res.data[0].url) {
          this.$message({
            message: 'download url is null',
          });
        } else {
          this.$copyText(res.data[0].url).then(() => {
            this.$message('Copied');
          }, () => {
            this.$message('Can not copy');
          });
        }
      } catch (e) {
        console.log(e);
        this.$message({
          message: 'fail',
        });
      }
    },
    async handleDownload(i, item) {
      const down = document.querySelector('#download');
      try {
        const res = await downloadUrl({ place_id: this.place, version: item.version, status: item.status });
        console.log(res, 'resss');
        down.href = `${window.location.protocol}//${window.location.hostname}${res.data[0].url}`;
        if (!res.data[0].url) {
          this.$message({
            message: 'download url is null',
          });
        } else {
          down.click();
          // setTimeout(() => {

          // }, 0);
        }
      } catch (e) {
        console.log(e);
        this.$message({
          message: 'fail',
        });
      }
    },
    async handlePublish(i, item) {
      console.log(i, item, 'iiii');
      try {
        const res = await updateData({ place_id: this.place, status: item.status, version: item.version });
        console.log(res, 'pub');
        this.$message({
          message: 'success',
          type: 'success',
        });
        this.packageList(this.place, this.activeName);
      } catch (e) {
        this.$message({
          message: 'fail',
        });
        console.log(e);
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.page_size = val;
      this.packageList(this.place, this.activeName);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.packageList(this.place, this.activeName);
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="less">
.offline{
  padding:20px;
  &-title{
    background: #fff;
    padding:10px;
    border-radius: 10px;
    label{
      margin-right:20px;
    }
    .newAddBtn{
      float: right;
    }
  }
  &-body{
    margin-top:20px;
    .dataTable,.pagebar{
      margin-top:15px;
    }

    .pagebar{
      text-align: center;
    }

  }
}
</style>
